import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { NFTItemIcon } from "../Icons/NFTItemIcon";

export const LazyVideoItem = (props) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const {image, source} = props;
  const [isInView, setIsInView] = useState(false);
  const [showVideo, setShowVideo] = useState(false);
  const itemRef = useRef(null);

  useEffect(() => {
    if (showVideo) {
      const video = videoRef.current;
      video.addEventListener('timeupdate', () => {
        if (video.currentTime >= 5) {
          video.currentTime = 0;
          video.play(); 
        }
      });
      video.addEventListener('loadedmetadata', () => {
        
      });
      return () => {
        video.removeEventListener('loadedmetadata', () => {});
        video.removeEventListener('timeupdate', () => {});
      };
    }
    
  }, [showVideo]);


  useEffect(() => {
    if (showVideo) {
      setTimeout(() => {
        videoRef.current.play()
      }, 1000)
    }
  }, [showVideo])
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        }
      },
      { threshold: 0.5 } 
    );

    if (itemRef.current) {
      observer.observe(itemRef.current);
    }

    return () => {
      if (itemRef.current) {
        observer.unobserve(itemRef.current);
      }
    };
  }, []);

  useEffect(() => {
    if (isInView) {
      setTimeout(() => {
        setShowVideo(true); 
      }, 300); 
    }
  }, [isInView]);
  return (
    <div
        className={`${props?.className} video-loop h-full w-full`}
      >
        <div className='mobile-loop-custom h-full w-full' ref={itemRef}>
          {showVideo ? <video
            ref={videoRef}
            muted={true}
            playsInline={true}
            loop={true}
            autoPlay={true}
          >
            <source src={source} type="video/mp4"></source>
          </video>: <img
            src={image}
            className="w-full h-full object-cover"
            alt="Thumbnail" /> }
        </div>
      </div>
  );
};

export default LazyVideoItem;
